import React from "react"
import { connect } from "react-redux"
import { DckActionCreators, DckSelectors } from "dck-redux"
import {
  investorDataWithId,
  sortInvestors,
  validateMinMaxState,
  validateTextState,
  VALIDATION_TYPE
} from "../../../lib/utils"
import apiServerApi from "../../../redux/sagas/apiServerApi"
import * as ItemTypes from "../../../redux/items/types"
import { blockingFetchService } from "../../../lib/blockingFetch"
import { Button, Col, Modal, Row } from "react-bootstrap"
import FormControlInlineSelect from "../../fragments/FormControl.Inline.Select"
import FormControlInlineInput from "../../fragments/FormControl.Inline.Input"
import ProcessesStatus from "../../fragments/ProcessesStatus"
import FontAwesome from "react-fontawesome"
import PeriodSelect from "./PeriodSelect"

class AddMoneyCard extends React.Component {

  constructor(props) {
    super(props)
    this.initView()
  }

  initView = () => {
    this.state = {
      isAddMoney: true,
      amount: '',
      investorId: '',
      investorName: '',
      bankName: '',
      walletAddress: '',
      period: '',
      periodType: 'DAYS',
      running: false,
      success: false,
      error: null,
      amountValidationState: VALIDATION_TYPE.NULL,
      investorIdValidationState: VALIDATION_TYPE.NULL,
      investorNameValidationState: VALIDATION_TYPE.NULL,
      bankNameValidationState: VALIDATION_TYPE.NULL,
      periodValidationState: VALIDATION_TYPE.NULL,
      periodTypeValidationState: VALIDATION_TYPE.NULL,
      walletAddressValidationState: VALIDATION_TYPE.NULL,
    }
  }

  componentDidMount() {
    this.props.loadInvestors()
  }

  amountChanged = amount => this.setState({
    amount,
    amountValidationState: validateMinMaxState(amount, 1, null, false),
    error: null,
  })

  investorIdChanged = investorId => this.setState({
    investorId,
    investorIdValidationState: validateTextState(investorId, false),
    error: null,
  })

  investorNameChanged = investorName => this.setState({
    investorName,
    investorNameValidationState: validateTextState(investorName, false),
    error: null,
  })

  bankNameChanged = bankName => this.setState({
    bankName,
    bankNameValidationState: validateTextState(bankName, true),
    error: null,
  })

  periodChanged = period => this.setState({
    period,
    periodValidationState: validateMinMaxState(period, 1, 4096, false),
    error: null,
  })

  periodTypeChanged = periodType => this.setState({
    periodType,
    periodTypeValidationState: validateTextState(periodType, false),
    error: null,
  })

  walletAddressChanged = walletAddress => this.setState({
    walletAddress,
    walletAddressValidationState: validateTextState(walletAddress, true),
    error: null,
  })

  validateAddMoneyData = () => {

    const { investorId, amount, period } = this.state,
    investorIdValid = validateTextState(investorId, false),
    amountValid = validateMinMaxState(amount, 1, null, false),
    periodValid = validateMinMaxState(period, 1, 4096, false)

    this.setState({
      investorIdValidationState: investorIdValid,
      amountValidationState: amountValid,
      periodValidationState: periodValid,
    })

    return investorIdValid === VALIDATION_TYPE.SUCCESS
      && amountValid === VALIDATION_TYPE.SUCCESS
      && periodValid === VALIDATION_TYPE.SUCCESS
  }

  confirmAddMoney = () => {

    if(!this.validateAddMoneyData()) {
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { bucketId, setFinancierBucket } = this.props,
    { investorId, amount, period, periodType } = this.state,
    data = { investor: { id: investorId }, amount, period, periodType }

    blockingFetchService(
      accessToken => apiServerApi.addMoneyFinancierFucket(accessToken, bucketId, data),
      resp => {
        this.setState({ success: true })
        setTimeout(this.closeForm, 1000)
        setFinancierBucket(bucketId, resp)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  validateInvestorData = () => {

    const { investorName, bankName, walletAddress } = this.state,
    investorNameValid = validateTextState(investorName, false),
    bankNameValid = validateTextState(bankName, true),
    walletAddressValid = validateTextState(walletAddress, true)

    this.setState({
      investorNameValidationState: investorNameValid,
      bankNameValidationState: bankNameValid,
      walletAddressValidationState: walletAddressValid
    })

    return investorNameValid === VALIDATION_TYPE.SUCCESS
      && bankNameValid !== VALIDATION_TYPE.ERROR
      && walletAddressValid !== VALIDATION_TYPE.ERROR
  }

  confirmCreateInvestor = () => {

    if(!this.validateInvestorData()) {
      return
    }

    this.setState({
      running: true,
      success: false,
      error: null,
    })

    const { investorName: name, bankName, walletAddress  } = this.state,
    data = { name, bankName, walletAddress }

    blockingFetchService(
      accessToken => apiServerApi.saveInvestor(accessToken, data),
      resp => {

        this.props.setInvestor(resp.id, resp)
        this.investorIdChanged(resp.id)
        this.setState({ success: true })

        setTimeout(() => this.changeView(true), 800)
      },
      error => this.setState({ error: error.text }),
      _ => this.setState({ running: false })
    )
  }

  closeForm = () => {
    this.initView()
    const { close } = this.props
    close()
  }

  changeView = isAddMoney => this.setState({
    isAddMoney,
    investorName: '',
    bankName: '',
    walletAddress: '',
    running: false,
    success: false,
    error: null,
    investorNameValidationState: VALIDATION_TYPE.NULL,
    bankNameValidationState: VALIDATION_TYPE.NULL,
    walletAddressValidationState: VALIDATION_TYPE.NULL,
  })

  renderCreateInvestor = () => {

    const { investorName, bankName, walletAddress, investorNameValidationState,
      bankNameValidationState, walletAddressValidationState, running, } = this.state

    return (
      <Col xs={12}>
        <FormControlInlineInput controlId="name" validationState={ investorNameValidationState }
          label='Investor name *' placeholder='Enter name' value={ investorName }
          onChange={ this.investorNameChanged }
          helpText={ investorNameValidationState === VALIDATION_TYPE.ERROR ? 'Name is required' : '' }
          disabled={ running }
        />

        <FormControlInlineInput controlId="bankName" validationState={ bankNameValidationState }
          label='Bank name' placeholder='Bank name' value={ bankName }
          onChange={ this.bankNameChanged }
          disabled={ running }
        />

        <FormControlInlineInput controlId="walletAddress" validationState={ walletAddressValidationState }
          label='Wallet address' placeholder='0x657...' value={ walletAddress }
          onChange={ this.walletAddressChanged }
          disabled={ running }
        />
      </Col>
    )
  }

  renderAddMoneyContent = () => {

    const { investorId, amount, period, periodType, investorIdValidationState,
      periodValidationState, amountValidationState, running } = this.state,

    { investorData } = this.props

    return (
      <Col xs={12}>

        <FormControlInlineSelect
          controlId='investorId' validationState={ investorIdValidationState }
          label='Investor *' value={ investorId } 
          onChange={ this.investorIdChanged }
          options={ investorData }
          withEmptyOption={ true }
          helpText={ investorIdValidationState === VALIDATION_TYPE.ERROR ? 'Select a value' : '' }
          disabled={ running }
        />

        <FormControlInlineInput controlId='amount' validationState={ amountValidationState }
          label='Amount *' placeholder='Enter amount' value={ amount }
          onChange={ this.amountChanged }
          helpText={ amountValidationState === VALIDATION_TYPE.ERROR ? 'Invalid amount' : '' }
          disabled={ running }
        />

        <PeriodSelect
          id='period'
          value={ period }
          placeholder='Enter number'
          validationState={ periodValidationState }
          periodType={ periodType }
          onChange={ this.periodChanged }
          onChangePeriodType={ this.periodTypeChanged }
          help={ periodValidationState === VALIDATION_TYPE.ERROR ? 'Invalid period' : '' }
          disabled={ running }
        />
      </Col>
    )
  }

  renderContent = () => {

    const { running, success, error, isAddMoney } = this.state

    return (
      <div>
        <Row>
          { isAddMoney ? this.renderAddMoneyContent() : this.renderCreateInvestor() }
        </Row>
        <ProcessesStatus error={ error } running={ running } success={ success } />
      </div>
    )
  }

  getTitle = bucketName => {

    const { isAddMoney } = this.state

    return isAddMoney ?
    <span>
      <Button href='#' onClick={() => this.changeView(false)} className='mr-15' bsStyle='link'>
        <FontAwesome name='plus-circle' /> New Investor
      </Button> Add Money to <strong>&#171; { bucketName } &#187;</strong>
    </span>
    :
    <span>
      <span className="cursor-pointer p-10 mr-15" onClick={() => this.changeView(true)}>
        <FontAwesome name='arrow-left' />
      </span> Create Investor
    </span>
  }

  getFooter = () => {

    const { isAddMoney, running } = this.state

    return (
      <Modal.Footer>
        { isAddMoney && <Button onClick={ this.closeForm }>Cancel</Button> }

        { isAddMoney ?
        <Button onClick={ this.confirmAddMoney } bsStyle='primary' disabled={ running } className='w-100'>
          Save
        </Button>
        :
        <Button onClick={ this.confirmCreateInvestor } bsStyle='success' disabled={ running }>
          Create Investor
        </Button> }
      </Modal.Footer>
    )
  }

  render() {

    const { show, bucketName } = this.props,
    { isAddMoney, running, success, error  } = this.state

    return (
      <Modal show={ show } onHide={ this.closeForm }>

        <Modal.Header closeButton>
          <Modal.Title>{ this.getTitle(bucketName) }</Modal.Title>
        </Modal.Header>

        <Modal.Body>
          <Row>
            { isAddMoney ? this.renderAddMoneyContent() : this.renderCreateInvestor() }
          </Row>
          <ProcessesStatus error={ error } running={ running } success={ success } />
        </Modal.Body>

        { this.getFooter() }

      </Modal>
    )
  }
}

const mapStateToProps = state => {

  const investors = DckSelectors.selectAllItems(state, ItemTypes.Investor)
  sortInvestors(investors)
  const investorData = investorDataWithId(investors)

  return { investorData }
},

mapDispatchToProps = dispatch => ({
  loadInvestors: () => dispatch(DckActionCreators.itemsLoad(ItemTypes.Investor)),
  setInvestor: (id, data) => dispatch(DckActionCreators.itemSet(ItemTypes.Investor, id, data)),
})

export default connect(mapStateToProps, mapDispatchToProps)(AddMoneyCard)



// WEBPACK FOOTER //
// ./src/components/Financiers/Buckets/AddMoneyCard.js